import { FC } from 'react';
import RemoveIcon from '@mui/icons-material/RemoveCircleOutline';
import EditIcon from '@mui/icons-material/Edit';

import { INameTitle } from 'src/types/org/common/nameTitleSchema';
import { WordBreak } from 'src/components';
import { IconButton, ItemCard, ItemRow } from 'src/generic/component';

interface INameTitleProps {
  item: INameTitle;
  isEditing: boolean;
  readOnly?: boolean;
  onRemove: (item: INameTitle) => void;
  onEdit: (item: INameTitle) => void;
}

export const NameTitleDetails: FC<INameTitleProps> = ({ item, isEditing, readOnly, onRemove, onEdit }) => {
  const handleRemove = (value: INameTitle) => {
    onRemove(value);
  };

  const handleEdit = (value: INameTitle) => {
    onEdit(value);
  };

  return <ItemRow>
    <ItemCard>
      {!readOnly &&
        <div style={{ marginRight: '8px' }}>
          {isEditing ?
            <div>&nbsp;</div> :
            <IconButton onClick={() => { handleRemove(item); }}>
              <RemoveIcon />
            </IconButton>
          }
          <IconButton style={{ color: isEditing ? '#fa921b' : undefined }} onClick={() => {
            handleEdit(item);
          }} ><EditIcon /></IconButton>
        </div>
      }
      <div>
        <WordBreak>
          <WordBreak><span style={{ fontWeight: 500 }}>Name:</span> {item.name}</WordBreak>
          <WordBreak><span style={{ fontWeight: 500 }}>Title:</span> {item.title}</WordBreak>
        </WordBreak>
      </div>
    </ItemCard>
  </ItemRow>;
};